import arLocale from 'element-ui/lib/locale/lang/ar' //引入element语言包
const ar = {
  Login: {
    ToLogin: 'سجل',
    PhoneLogin: 'رقم الهاتف',
    EmailLogin: 'تسجيل الدخول',
    PhonePlaceholder: 'الرجاء إدخال رقم الهاتف',
    EmailPlaceholder: 'Enter email',
    Code: 'رمز التحقق',
    and: 'و .',
    BeforeText: 'إنشاء حساب باسم موافقتك والالتزام',
    UserAgreement: 'بروتوكول المستخدم',
    privacy: 'سياسة الخصوصية',
    errorMessage: 'رمز التحقق من الخطأ',
    readTitle: 'قراءة والموافقة على الاتفاق التالي',
    readBefore: 'لضمان أمن المعلومات الشخصية الخاصة بك ، يرجى قراءة والموافقة على',
    cancel: 'ألغى',
    agree: 'الموافقة على الاستمرار',
    error1:'الرجاء إدخال عنوان بريد إلكتروني صالح',
    error2:'الرجاء إدخال رقم الهاتف الصحيح',
    error3:'الرجاء إدخال رمز التحقق',
    success:'تسجيل الدخول بنجاح'
  },
  ...arLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default ar;
